'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormDataFromQueryParams = exports.getFormDataForFieldsWithSingleValue = exports.getQueryParams = exports.getNextIdNumber = exports.parseFields = undefined;

var _isNan = require('babel-runtime/core-js/number/is-nan');

var _isNan2 = _interopRequireDefault(_isNan);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _escapeStringRegexp = require('escape-string-regexp');

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
  string: 'text',
  boolean: 'checkbox'
  //  number: 'dropdown',
};

var formats = {
  email: 'email',
  uri: 'URL'
};

var widgets = {
  textarea: 'textarea',
  maskedInput: 'masked',
  updown: 'number',
  password: 'password',
  radio: 'radio',
  checkboxes: 'checkboxMultiple',
  select: 'dropdown',
  dateTime: 'datepicker',
  staticText: 'staticText',
  button: 'button',
  phoneInput: 'phoneInput',
  filesAsync: 'filesAsync'
};

var parseFields = exports.parseFields = function parseFields(jsonschema, uischema) {
  var formMetaData = uischema.formMetaData;

  var required = jsonschema.required;

  if (!('properties' in jsonschema)) return [{}];
  var fields = uischema['ui:order'].map(function (key) {
    var typeName = _ramda2.default.path(['properties', key, 'type'], jsonschema);
    if (!typeName) return undefined;
    var type = types[typeName];
    if (widgets[uischema[key]['ui:widget']]) {
      type = widgets[uischema[key]['ui:widget']];
    } else if (jsonschema.properties[key].format) {
      type = formats[jsonschema.properties[key].format];
    }
    //    if (jsonschema.properties[key].enum && jsonschema.properties[key].enumNames) {
    //      type = 'dropdown'
    //    }

    var enumItems = _ramda2.default.path(['properties', key, 'items'], jsonschema);
    if (enumItems && !('enumNames' in enumItems)) {
      enumItems.enumNames = enumItems.enum;
    }
    var enums = _ramda2.default.path(['properties', key, 'enum'], jsonschema);
    var enumNames = _ramda2.default.path(['properties', key, 'enumNames'], jsonschema);
    //    console.log('enumItems', enumItems, 'enums', enums, 'enumNames', enumNames)
    var items = void 0;
    if (enumItems) {
      items = enumItems;
    } else if (enums) {
      items = {
        enum: enums,
        enumNames: enumNames || enums
      };
    }

    var datasourceData = (jsonschema.datasource_fields || []).filter(function (unit) {
      return unit.property === key;
    })[0];
    var itemsDataSource = void 0;
    var itemsDataSourceId = void 0;
    var itemsDataSourceFilters = void 0;

    if (datasourceData) {
      itemsDataSourceId = datasourceData.id;
      itemsDataSourceFilters = _ramda2.default.path(['properties', key, 'itemsDataSourceFilters'], jsonschema);

      itemsDataSource = [];

      var _enums = jsonschema.properties[key].enum || [];

      _enums.forEach(function (value, index) {
        var object = {
          id: value,
          name: jsonschema.properties[key].enumNames[index]
        };

        itemsDataSource.push(object);
      });
    }

    var result = (0, _extends3.default)({}, jsonschema.properties[key], {
      isRequired: _ramda2.default.contains(key, required),
      itemsDataSource: itemsDataSource,
      itemsDataSourceId: itemsDataSourceId,
      itemsDataSourceFilters: itemsDataSourceFilters,
      wrapperClassNames: _ramda2.default.propOr('', 'ui:inputClassNames', uischema[key]),
      classNames: _ramda2.default.propOr('', 'classNames', uischema[key]),
      mask: _ramda2.default.propOr('', 'ui:mask', uischema[key]),
      pattern: _ramda2.default.propOr('', 'ui:pattern', uischema[key]),
      masterFieldId: _ramda2.default.propOr('', 'ui:masterFieldId', uischema[key]),
      placeholder: _ramda2.default.propOr('', 'ui:placeholder', uischema[key]),
      staticTextContent: _ramda2.default.propOr('', 'ui:content', uischema[key]),
      buttonType: _ramda2.default.propOr('', 'ui:type', uischema[key]),
      country: _ramda2.default.propOr('', 'ui:country', uischema[key]),
      fileSizeMin: _ramda2.default.propOr(0, 'ui:fileSizeMin', uischema[key]),
      fileSizeMax: _ramda2.default.propOr(10000, 'ui:fileSizeMax', uischema[key]),
      totalFilesSizeLimit: _ramda2.default.propOr(20000, 'ui:totalFilesSizeLimit', uischema[key]),
      totalFilesCount: _ramda2.default.propOr(1, 'ui:totalFilesCount', uischema[key]),
      fileExtensions: _ramda2.default.propOr('', 'ui:fileExtensions', uischema[key]),
      fileUploadHint: _ramda2.default.propOr('', 'ui:hint', uischema[key]),
      fileUploadButtonLabel: _ramda2.default.propOr('', 'ui:addButtonLabel', uischema[key]),
      dateTimeWidgetType: _ramda2.default.propOr('', 'ui:dateTimeWidgetType', uischema[key]),
      dateTimeAvailableDates: _ramda2.default.propOr('any', 'ui:dateTimeAvailableDates', uischema[key]),
      type: type,
      key: key,
      items: items
      //    if ('ui:fileSizeMin' in uischema[key]) {
      //      result.fileSizeMin = R.prop('ui:fileSizeMin', uischema[key])
      //    }
      //    if ('ui:fileSizeMax' in uischema[key]) {
      //      result.fileSizeMax = R.prop('ui:fileSizeMax', uischema[key])
      //    }
      //    if ('ui:totalFilesSizeLimit' in uischema[key]) {
      //      result.totalFilesSizeLimit = R.prop('ui:totalFilesSizeLimit', uischema[key])
      //    }
      //    if ('ui:totalFilesCount' in uischema[key] && R.prop('ui:totalFilesCount', uischema[key])) {
      //      result.totalFilesCount = R.prop('ui:totalFilesCount', uischema[key])
      //    }
      //    if ('ui:fileExtensions' in uischema[key]) {
      //      result['fileExtensions'] = R.prop('ui:fileExtensions', uischema[key])
      //    }
      //    if ('ui:hint' in uischema[key]) {
      //      result.fileUploadHint = R.prop('ui:hint', uischema[key])
      //    }
      //    if ('ui:addButtonLabel' in uischema[key]) {
      //      result.fileUploadButtonLabel = R.prop('ui:addButtonLabel', uischema[key])
      //    }
    });return result;
  });
  console.log('fields', fields);
  return _ramda2.default.filter(_ramda2.default.identity, fields);
};

var parseIntOrNull = function parseIntOrNull(x) {
  var result = parseInt(x, 10);
  if (isNaN(result)) {
    return undefined;
  }
  return result;
};

var getNextIdNumber = exports.getNextIdNumber = _ramda2.default.compose(_ramda2.default.inc, _ramda2.default.ifElse(_ramda2.default.isEmpty, _ramda2.default.always(0), _ramda2.default.apply(Math.max)), _ramda2.default.filter(_ramda2.default.identity), _ramda2.default.map(_ramda2.default.compose(parseIntOrNull, _ramda2.default.last, _ramda2.default.filter(_ramda2.default.identity), _ramda2.default.split(/(\d+)$/), _ramda2.default.propOr('', 'key'))));

var getQueryParams = exports.getQueryParams = function getQueryParams() {
  try {
    var search = window.location.search.substring(1);

    var processedSearchString = decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"');

    return JSON.parse('{"' + processedSearchString + '"}');
  } catch (e) {
    return {};
  }
};

/* eslint-disable no-param-reassign */
var getFormDataForFieldsWithSingleValue = exports.getFormDataForFieldsWithSingleValue = function getFormDataForFieldsWithSingleValue(schema, uiSchema, formId) {
  var formData = {};

  var requiredParams = schema.required;
  var dependendFields = (0, _keys2.default)(((window.fs_mappings || {})[formId] || {}).filters || {});

  (0, _entries2.default)(schema.properties).forEach(function (propertyEntry) {
    var _propertyEntry = (0, _slicedToArray3.default)(propertyEntry, 2),
        propertyId = _propertyEntry[0],
        property = _propertyEntry[1];

    var isRequired = requiredParams.indexOf(propertyId) !== -1;
    var isDependend = dependendFields.indexOf(propertyId) !== -1;

    if (!isRequired && !isDependend) {
      return;
    }

    var enumValues = void 0;

    if (!!property.items && Array.isArray(property.items.enum)) {
      enumValues = property.items.enum;
    } else if (Array.isArray(property.enum)) {
      enumValues = property.enum;
    }

    if (!!enumValues && enumValues.length === 1) {
      formData[propertyId] = property.type === 'array' ? [enumValues[0]] : enumValues[0];

      uiSchema[propertyId]['ui:disabled'] = true;
    }
  });

  return formData;
};

var getFormDataFromQueryParams = exports.getFormDataFromQueryParams = function getFormDataFromQueryParams(schema, uiSchema, params) {
  var formData = {};

  var booleanTrueValues = ['1', 1, 'Да', 'да', 'Yes', 'yes', 'y', 'Y', true];

  var availableParameters = (0, _keys2.default)(schema.properties);

  (0, _entries2.default)(params).forEach(function (parameterEntry) {
    var isCorrectParameter = availableParameters.indexOf(parameterEntry[0]) !== -1;

    if (isCorrectParameter) {
      var propertyKey = parameterEntry[0];
      var propertyRawValue = parameterEntry[1];

      var schemaParameter = schema.properties[propertyKey];
      var uiSchemaParameter = uiSchema[propertyKey];

      switch (schemaParameter.type) {
        case 'string':
          {
            var isDateWidget = uiSchemaParameter['ui:widget'] === 'dateTime';

            if (isDateWidget) {
              var dateType = uiSchemaParameter['ui:dateTimeWidgetType'] || 'datetime';
              var availableFor = uiSchemaParameter['ui:dateTimeAvailableDates'] || 'any';

              var dateFormat = 'DD.MM.YYYY HH:mm';

              if (dateType === 'date') {
                dateFormat = 'DD.MM.YYYY';
              } else if (dateType === 'time') {
                dateFormat = 'HH:mm';
              }

              var valueAsDate = (0, _moment2.default)(propertyRawValue, dateFormat, true);

              if (valueAsDate.isValid()) {
                var dateIsAvailable = true;
                if (availableFor === 'future') {
                  dateIsAvailable = valueAsDate.isAfter();
                } else if (availableFor === 'past') {
                  dateIsAvailable = valueAsDate.isBefore();
                }

                if (dateIsAvailable) {
                  formData[propertyKey] = propertyRawValue;
                }
              }
            } else if (!!schemaParameter.enum && Array.isArray(schemaParameter.enum)) {
              if (schemaParameter.enum.indexOf(propertyRawValue) !== -1) {
                formData[propertyKey] = propertyRawValue;
              }
            } else if (schemaParameter.pattern) {
              var patternRE = schemaParameter.pattern;
              var re = new RegExp(patternRE);

              if (re.test(decodeURIComponent(propertyRawValue))) {
                formData[propertyKey] = decodeURIComponent(propertyRawValue);
              }
            } else {
              formData[propertyKey] = propertyRawValue;
            }

            break;
          }
        case 'integer':
          {
            var number = parseInt(propertyRawValue, 10);

            if (!(0, _isNan2.default)(number)) {
              formData[propertyKey] = number;
            }

            break;
          }
        case 'boolean':
          {
            if (booleanTrueValues.indexOf(propertyRawValue) !== -1) {
              formData[propertyKey] = true;
            } else {
              formData[propertyKey] = false;
            }

            break;
          }
        case 'array':
          {
            if (!!schemaParameter.items && Array.isArray(schemaParameter.items.enum)) {
              var values = propertyRawValue.split(',');

              var correctValues = values.filter(function (v) {
                return schemaParameter.items.enum.indexOf(v) !== -1;
              });
              formData[propertyKey] = correctValues;
            }

            break;
          }
        default:
          break;
      }
    }
  });

  return formData;
};


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/formBuilder.js
// module id = 779
// module chunks = 5